module.exports = __webpack_public_path__ + "static/ilustracao-homologacao-f7b80484d2d45b60ca7e9788b89192e0.svg";